// Hooks / Node modules / Styles
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: "#ffffff", // Light background
      }}
      contentArrowStyle={{ borderRight: "7px solid  #f9f9f9" }} // Match the background color
      date={experience.duration}
      iconStyle={{
        background: "#fff", // White icon background
        border: "2px solid #ddd", // Light border for the icon
      }}
      icon={
        <div className="flex justify-center items-center w-full h-full ">
          <img
            src={experience.logo}
            alt={experience.company}
            className="w-[60%] h-[60%] object-contain"
          />
        </div>
      }
    >
      <div>
        <h3 className="text-black text-[24px] font-bold">{experience.title}</h3>
        <p
          className="text-gray-600 text-[16px] font-semibold"
          style={{ margin: 0 }}
        >
          {experience.company}
        </p>
        <p className="text-gray-500 text-[14px] mt-2">{experience.location}</p>
      </div>

      <p className="text-gray-700 text-[14px] mt-4 text-xs">
        {experience.description}
      </p>
    </VerticalTimelineElement>
  );
};

export default ExperienceCard;
